module.exports = "<div [@changeState]=\"currentState\" class = \"myblock mx-auto\"></div>"